/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useDeleteDraftClaim
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for delete draft claim
 *
 */
interface IProps {
	claimId: string;
}
const useDeleteDraftClaim = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ claimId }) => {
			await api.FHIRClaimApi.deleteClaim({ claimId });
		},
		onSuccess: () => {
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.deleteDraftClaim] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteDraftClaim;
